/**
 * Sets up a click event
 */
export function setup_menu_trigger()
{
	$('.menu-trigger').on('click', function (e){
		e.preventDefault();
		console.log('click');

		let body = $('body');

		if(body.hasClass('menu-active'))
		{
			body.removeClass('menu-active');
		}
		else
		{
			body.addClass('menu-active');
		}
	});
}

/**
 * Updates the menu based on the current url
 */
export function update_menu()
{
	//Update the menu aria-current page based on urls
	let url = window.location.href;

	//Remove the old current page attributes
	let current_page = $('.nav li.current-menu-item');
	current_page.removeClass('current-menu-item').find('a').attr('aria-current', '');

	//Find the new current page and add classes
	let active_items = $('.nav').find('a[href="' + url + '"]');
	active_items.each(function(){
		$(this).attr('aria-current', 'page');
		$(this).parent().addClass('current-menu-item');
	});
}

export function show_submenu()
{
	let parentLink = $('.header-menu > li');
	let subParent = $('.header-sub-menu');
	let currentId;
	let resetMenu = (showSub = false, subLink) => {
		let callback = showSub == true ? fadeInSub(subLink) : fadeOutSub(subLink);

		if (subLink)
		{	
			subLink.siblings()
				.removeClass('active')
				.stop(true, true)
				.fadeOut(200, callback);
		}
	}

	let fadeInSub = (subLink) => {
		let subMenuHeight = subLink.innerHeight();
		
		subParent.css('height', subMenuHeight);

		subLink.addClass('active')
			.stop(true, true)
			.fadeIn(200);

	}

	let fadeOutSub = () => {
		currentId = null;
		subParent.find('.menu-item-has-children')
			.stop(true, true)
			.fadeOut(100);
		
		subParent.css('height', '');
	}

	parentLink.on('mouseenter', function () {

		if (window.innerWidth < 1080)
		{
			return	
		}
		
		let linkId = $(this).attr('id');
		let subLink = subParent.find(`#${linkId}`);

		currentId = linkId;

		if (subLink && subLink.hasClass('menu-item-has-children'))
		{
			resetMenu(true, subLink);
		}
		else
		{
			resetMenu(false, subLink);
		}
	});

	$('.header-nav').on('mouseleave', () => {
		
		if (window.innerWidth < 1080)
		{
			return	
		}

		resetMenu(false);
	});
}

export function subMenuShowHide()
{
	let parentLink = $('.menu-item-has-children').find('a[href="#"]');

	parentLink.on('click', function (e)
	{
		let parent = $(this).parents('.menu-item-has-children');

		e.stopPropagation();
    e.preventDefault();

		if (parent.hasClass('active'))
		{
			parent.removeClass('active')
				.find('.sub-menu').slideUp(400);
		}
		else
		{
			parent.addClass('active')
				.find('.sub-menu')
				.slideDown(400);
			
			parent.siblings()
				.removeClass('active')
				.find('.submenu').slideUp(400);	
		}
	})
}

export function closeMenu()
{
	$('.popup-menu').find('.sub-menu').slideUp(400);
	$('.popup-menu').find('.menu-item-has-children').removeClass('active');
}



// WEBPACK FOOTER //
// ./scripts/modules/menu.js